(function () {
  'use strict';

  var motionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  var observer = null;

  function enabled() {
    return document.documentElement.classList.contains('es-motion-enabled')
      && !(motionQuery && motionQuery.matches);
  }

  function markVisible(node) {
    if (!node) return;
    node.classList.add('is-visible');
    delete node.dataset.escosySharedRevealObserved;
  }

  function ensureObserver() {
    if (observer || !enabled() || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        markVisible(entry.target);
        if (observer) observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    return observer;
  }

  function reveal(node) {
    if (!node) return;
    if (observer) observer.unobserve(node);
    markVisible(node);
  }

  function observe(node) {
    if (!node) return;
    var sharedObserver = ensureObserver();

    if (!sharedObserver) {
      reveal(node);
      return;
    }

    node.dataset.escosySharedRevealObserved = 'true';
    sharedObserver.observe(node);
  }

  function cleanup(root) {
    if (!root || !root.querySelectorAll || !observer) return;
    root.querySelectorAll('[data-escosy-shared-reveal-observed]').forEach(function (node) {
      observer.unobserve(node);
      delete node.dataset.escosySharedRevealObserved;
    });
  }

  function revealAll() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    document.querySelectorAll('[data-reveal], [data-escosy-reveal]').forEach(reveal);
  }

  function handleMotionPreferenceChange() {
    if (!enabled()) revealAll();
  }

  if (motionQuery) {
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', handleMotionPreferenceChange);
    } else if (motionQuery.addListener) {
      motionQuery.addListener(handleMotionPreferenceChange);
    }
  }

  window.EscosyReveal = {
    cleanup: cleanup,
    enabled: enabled,
    observe: observe,
    reveal: reveal
  };
})();
